<div id="sidecontainer">
  <child-header title="End User Portal Management" (closeEvent)="closePage()"></child-header>
  <!-- <div class="pageTitle"> -->
    <!-- <i class="material-icons closebutton-pullfloat-right" (click)="closePage()" title="close">close</i> -->
    <!-- <img src="../images/new_ui/cross-button-gray.png" class="pullfloat-right" (click)="closePage()" alt=""> -->
  <!-- </div> -->

  <!-- <div class="title blade-title-font blade-title-position col-md-12">End User Portal Management</div> -->

  <div class="child-body">
    <ng-container *ngIf="tab==='Portal'">


      <loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="400"
                      (currentLoadingStatus)="onLoading($event)"></loading-screen>

      <!-- Accordion -->

      <mat-accordion>

        <!-- BRANDING-->
        <mat-expansion-panel [expanded]="true" class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title>
              BRANDING
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- color picker-->
          <div class="row no-gutters">


            <div class="title bradning-title col-md-12 my-3">Select Site Color</div>


            <input id="color-picker" [style.background]="color" [cpPosition]="'bottom'" [cpCancelButton]="true" [cpOKButton]="true"
                  [cpCancelButtonClass]="'btn-primary btn btn-xs cancel-btn'" [cpOKButtonClass]="'btn-primary btn btn-xs'" [cpPositionRelativeToArrow]="true"
                  [(colorPicker)]="color">

            <div class="title bradning-title col-md-12 my-3">{{color}}</div>

          </div>

          <!-- image dropbox-->
          <div class="row  no-gutters">

            <div class="title bradning-title col-md-12 mb-3">Upload Company Logo <span
              class="basic-icon information-icon" placement="right"
              ngbTooltip="Image size will be resized to 400 width, 100 height"></span></div>

            <div class="custom-dropzone" [multiple]="false" [maxFileSize]="1000000" ngx-dropzone
                [accept]="'image/*'" (change)="onSelect($event)">
              <ngx-dropzone-label>
                <div>
                  <h2>Drop Here</h2>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" class="dropzone-image-preview"
                                          *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                <!-- <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label> -->
              </ngx-dropzone-image-preview>
            </div>
          </div>

          <div class="row  no-gutters mt-3">
            <div class="slide-toggle" style="margin:auto">
              <button (click)="deleteImage()" [disabled]="!uploadFile"
                      class="button button-red button-large">Delete Company Logo
              </button>
            </div>
          </div>

        </mat-expansion-panel>


        <!-- PREFERENCES-->
        <mat-expansion-panel class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title>
              PREFERENCES
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- set purchase access-->
          <div class="row  no-gutters">
            <div class="title bradning-title col-md-12 my-3">Allow users to add new Subscriptions</div>

            <div class="slide-toggle">
              <mat-slide-toggle [(ngModel)]="access"></mat-slide-toggle>
            </div>

          </div>

          <!-- set hide pricing-->
          <div class="row  no-gutters">
            <div class="title bradning-title col-md-12 my-3">Hide Pricing</div>

            <div class="slide-toggle">
              <mat-slide-toggle [(ngModel)]="hidePricing"></mat-slide-toggle>
            </div>

          </div>

          <!-- Notification Email-->
          <div class="row  no-gutters">

            <div class="title bradning-title col-md-12 mt-3">Enter an email address below if you wish to receive
              change notifications
            </div>

            <mat-form-field [floatLabel]="'always'" style="margin-left:20px;margin-right:20px">
              <input matInput [(ngModel)]="notificationEmail">
            </mat-form-field>

          </div>

        </mat-expansion-panel>

        <!-- CONTACT US-->
        <mat-expansion-panel  class="mt-3">

          <p>The below contact details will be displayed to your customers on the Contact Us page of the portal</p>

          <mat-expansion-panel-header>
            <mat-panel-title>
              CONTACT DETAILS
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row  no-gutters">

            <div [formGroup]="contactUsForm">

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="Company Name" formControlName="companyName">

              </mat-form-field>

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="Address Line 1" formControlName="address1">
              </mat-form-field>

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="Address Line 2" formControlName="address2">
              </mat-form-field>

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="Suburb" formControlName="suburb">
              </mat-form-field>

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="State" formControlName="state">
              </mat-form-field>

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="Post Code" formControlName="postcode">
                <mat-error *ngIf="contactUsForm.get('postcode').invalid">Post Code is not valid</mat-error>
              </mat-form-field>

              <mat-form-field [floatLabel]="'always'">
                <input matInput placeholder="Contact Email" formControlName="contactEmail">
                <mat-error *ngIf="contactUsForm.get('contactEmail').invalid">Contact Email is not valid</mat-error>

              </mat-form-field>

              <mat-form-field class="mt-2" [floatLabel]="'always'">
                <input matInput placeholder="Contact Phone" formControlName="contactPhone">
                <mat-error *ngIf="contactUsForm.get('contactPhone').invalid">Contact Phone is not valid</mat-error>
              </mat-form-field>

            </div>

          </div>

        </mat-expansion-panel>


        <div class="row  no-gutters mb-5">
          <div class="slide-toggle" style="margin:auto">
            <button id="updateBandingBtn" class="button button-red button-large"
                    (click)="updateTenantBranding()">Update Tenant Branding
            </button>
          </div>
        </div>

      </mat-accordion>

    </ng-container>


    <ng-container *ngIf="tab==='Enduser'">

      <!-- <p class="ml-3" style="margin-top:30px">Search users from this tenant to add to your management group</p>

      <div class="row no-gutters">
        <div class="searchInputGroup filterInputPosition ml-3" [formGroup]="searchUserForm">
          <div class="searchIcon">
            <img src="../images/new_ui/searchIcon-gray.png">
          </div>
          <input formControlName="userName" class="searchInput" placement="bottom" type="text"
                placeholder="Search Users" onfocus="this.placeholder=''" onblur="this.placeholder='Search Users'">
        </div>

        <button class="button button-red invite-user-btn" [class.active]="isManuallyInvite"
                (click)="toggleManuallyInvite()">Invite users manually
        </button>
      </div> -->

      <!-- <ng-container>

        <div class="mt-4">

          <loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="400"
                          (currentLoadingStatus)="onLoading($event)"></loading-screen>

          <div class="table-wrapper-scroll-y">
            <table class="table table-borderless">
              <thead>
              <tr>
                <th scope="col" style="width: 30%;">UserName</th>
                <th scope="col" style="width: 60%;">Email</th>
                <th scope="col" style="width: 10%;"></th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let user of searchedTenantUsers;index as i">
                <tr>
                  <td>{{user.displayName}}</td>
                  <td>{{user.userPrincipalName}}</td>
                  <td>
                    <button class="button button-red button-small"
                            (click)="addEndUser(user,i)">Add
                    </button>
                  </td>
                <tr>
              </ng-container>
              </tbody>

            </table>
          </div>

        </div>

      </ng-container> -->

      <ng-container>

        <div class="mt-4" [formGroup]="addUserForm">

          <loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="400"
                          (currentLoadingStatus)="onLoading($event)"></loading-screen>


          <table class="table table-borderless">

            <tbody>
            <tr style="border: none;">
              <td><input type="text" class="form-control" placeholder="Email Address"
                        formControlName="email"></td>
              <td style="width: 10%;">
                <button class="button button-red button-small mt-1"
                        (click)="addUserManually()">Add
                </button>
              </td>
            <tr>
            </tbody>

          </table>

        </div>

        <div *ngIf="EUDisplayText">
          <p class="ml-3" style="margin-top:30px">{{ EUDisplayText }}</p>
        </div>
        <div *ngIf="showReassign" class="reassignment-button">
          <button
            class="button button-red invite-user-btn"
            (click)="reassignEU()">Yes
          </button>
          <button
            class="button button-red invite-user-btn"
            (click)="donotReassignEU()">No
          </button>
        </div>


      </ng-container>

    </ng-container>
  </div>
</div>
